import { render, staticRenderFns } from "./Autograph.vue?vue&type=template&id=1f436250&scoped=true&"
import script from "./Autograph.vue?vue&type=script&lang=js&"
export * from "./Autograph.vue?vue&type=script&lang=js&"
import style0 from "./Autograph.vue?vue&type=style&index=0&id=1f436250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f436250",
  null
  
)

export default component.exports